module.exports = __webpack_public_path__ + "img/fifthGray.e2a46754.png";